import {
	Card,
	CardContent,
	Checkbox,
	FormControl,
	Grid,
	ListItemText,
	MenuItem,
	TextField,
	Tooltip,
	withStyles,
} from '@material-ui/core';
import { StyleRules } from '@material-ui/core/styles';
import Axios from 'axios';
import { forEach } from 'lodash';
import * as React from 'react';
import { FormattedDate, injectIntl } from 'react-intl';
import { Column } from 'react-table';

import { AccountLevelEnum, AccountStatusEnum, AccountSubscriptionEnum, UserRole } from '@app/app.enum';
import { history } from '@app/app.routes';
import { withAxiosCancellation } from '@app/components/core/axios-cancel.component';
import Table, { DefaultTableRowColor, ShadedTableRowColor } from '@app/components/shared/table.component';
import * as constants from '@app/constants';
import * as models from '@app/models';
import Injector from '@app/services';
import { AccountService } from '@app/services/account.service';
import { AdminAccountService } from '@app/services/admin-account.service';
import { IntlService } from '@app/services/intl.service';
import { SharedService } from '@app/services/shared.service';
import CustomButton from '@app/components/shared/custom-button.component';
import { ButtonTypeEnum } from '@app/app.enum';
// import ToggleButton from '@material-ui/lab/ToggleButton';
// import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { withRouter } from 'react-router';

const styles: StyleRules = {
	keyInput: {
		fontSize: 16,
		padding: '10px 14px',
	},
	textLabel: {
		fontSize: 18,
	},
};

const done = 'Done';
const AllLabel = 'All';
const NotApplicable = 'N/A';

const accountService: AccountService = Injector.get(AccountService);
const intlService: IntlService = Injector.get(IntlService);
const sharedService: SharedService = Injector.get(SharedService);
const adminAccountService: AdminAccountService = Injector.get(AdminAccountService);

type FilterType = 'customerSearch' | 'partnerSearch';

class CustomerListComponent extends React.Component<models.ICustomerListProps, models.ICustomerListState> {
	private userData: models.IUserSignInResponse;
	private prevFiltersInfo: models.IAdminCustomerPreviousFilters;
	private customerFilter: models.IAdminCustomerFilters = models.initialAdminCustomerFilter();
	private isPartnerAccount: boolean;
	private isAdminAccount: boolean;

	constructor(props: models.ICustomerListProps) {
		super(props);
		this.userData = accountService.getUserData();
		this.state = models.initialAdminCustomerState(this.userData, '');
		this.isPartnerAccount = this.userData.account.level === AccountLevelEnum.Partner;
		this.isAdminAccount = this.userData.account.level === AccountLevelEnum.Admin;
	}

	public async componentDidMount() {
		this.customerFilter.accountStatus = Object.values(AccountStatusEnum);
		this.customerFilter.accountSubscriptions = Object.values(AccountSubscriptionEnum);

		this.prevFiltersInfo = {
			selectedStatusFilterValues: [...this.customerFilter.accountStatus],
			selectedSubscriptionsFilterValues: [...this.customerFilter.accountSubscriptions],
			disabledCheckBox: { ...this.state.disabledCheckBox },
			selectAllStatusSelection: this.state.selectAllStatusSelection,
			selectAllSubscriptionSelection: this.state.selectAllSubscriptionSelection,
		};
		this.setState({
			selectedStatusFilterValues: [...this.customerFilter.accountStatus],
			selectedSubscriptionsFilterValues: [...this.customerFilter.accountSubscriptions],
		});
		if (this.isPartnerAccount) {
			this.setState({
				isPartnerFilter: false,
				selectedLevelTypeFilterValue: AccountLevelEnum.Customer,
			});
		}
		if (this.isAdminAccount) {
			this.updateLevelTypeFilter();
		}
	}

	public componentDidUpdate(prevProps: models.ICustomerListProps, prevState: models.ICustomerListState) {
		if (this.isAdminAccount) {
			if (this.props.match.params.levelType !== prevProps.match.params.levelType) {
				this.updateLevelTypeFilter();
			}
		}
	}

	public render() {
		return (
			<React.Fragment>
				<Grid container={true} direction='column' spacing={2}>
					<Grid item={true} xl={12} lg={12} xs={12}>
						<Card>
							<CardContent>
								<Grid container={true} spacing={2}>
									{this.renderCustomerSearchInput()}
									<Grid item={true} lg={3} md={3} sm={12} xs={12}>
										<FormControl fullWidth={true}>
											<TextField
												label={intlService.GetFormattedMessage('admin.customer-list.subscription-plan-label')}
												select={true}
												value={this.state.selectedSubscriptionsFilterValues}
												onChange={(e: React.ChangeEvent) => {
													this.filterHelperFunc(
														e,
														[...this.customerFilter.accountSubscriptions],
														'selectedSubscriptionsFilterValues',
														'selectAllSubscriptionSelection'
													);
												}}
												SelectProps={{
													open: this.state.isOpenSubscriptionsFilter,
													multiple: true,
													onClose: async () => {
														this.setState({
															...this.state,
															...this.prevFiltersInfo,
															isOpenSubscriptionsFilter: false,
															fetchData: false,
														});
													},
													onOpen: () =>
														this.setState({
															isOpenSubscriptionsFilter: !this.state.isOpenSubscriptionsFilter,
														}),
													renderValue: (selected) => {
														return this.state.selectAllSubscriptionSelection
															? AllLabel
															: (selected as string[])
																	.filter((x) => x !== UserRole.User)
																	.map((x) => x)
																	.join(', ');
													},
												}}
												variant='outlined'
											>
												<MenuItem
													key={intlService.GetFormattedMessage('app.filter-select-all')}
													value={intlService.GetFormattedMessage('app.filter-select-all')}
												>
													<Checkbox checked={this.state.selectAllSubscriptionSelection} />
													<ListItemText primary={intlService.GetFormattedMessage('app.filter-select-all')} />
												</MenuItem>
												{this.customerFilter.accountSubscriptions.map((x) => (
													<MenuItem key={x} value={x} disabled={this.state.disabledCheckBox[x]}>
														<Checkbox checked={this.state.selectedSubscriptionsFilterValues.includes(x)} />
														<ListItemText primary={x} />
													</MenuItem>
												))}
												<MenuItem
													className='text-center'
													key={intlService.GetFormattedMessage('app.filter-done')}
													value={intlService.GetFormattedMessage('app.filter-done')}
												>
													<ListItemText primary={intlService.GetFormattedMessage('app.filter-done')} />
												</MenuItem>
											</TextField>
										</FormControl>
									</Grid>
									<Grid
										item={true}
										lg={4}
										md={3}
										sm={12}
										xs={12}
										spacing={10}
										className='display-flex'
										alignItems='center'
									>
										<Grid container={true} direction='row' spacing={2}>
											{!this.isPartnerAccount && (
												<Grid item={true} lg={8} md={8} sm={12} xs={12}>
													<TextField
														fullWidth={true}
														label={intlService.GetFormattedMessage('admin.customer-list.account-type-label')}
														value={this.state.selectedLevelTypeFilterValue}
														onChange={(e: React.ChangeEvent<{ value: string }>) => {
															const cancelPreviousGetChildAccounts = this.callAfterCancellingActiveRequests(
																this.onAccountLevelTypeChange
															);
															cancelPreviousGetChildAccounts(e.target.value);
														}}
														select={true}
														SelectProps={{
															renderValue: (selected: any) => (selected as string[]).toString(),
														}}
														variant='outlined'
													>
														{[AccountLevelEnum.Customer, AccountLevelEnum.Partner].map(
															(value: AccountLevelEnum, index: number) => (
																<MenuItem key={index} value={value}>
																	<ListItemText
																		primary={this.props.intl.formatMessage({
																			id: `admin-account-details.${value.toLowerCase()}-label`,
																		})}
																	/>
																</MenuItem>
															)
														)}
													</TextField>
												</Grid>
											)}

											<Grid item={true} lg={4} md={4} sm={12} xs={12} alignContent='center'>
												{/* Search Button */}
												<CustomButton
													type={ButtonTypeEnum.Button}
													buttonText={intlService.GetFormattedMessage('app.common.search')}
													onClick={() => {
														this.getChildAccount(this.state.expandedRowIds);
													}}
												/>
											</Grid>
										</Grid>
									</Grid>

									{/*  Partner visible account number filter*/}
									{!this.isPartnerAccount && (
										<Grid item={true} lg={4} md={6} sm={12} xs={12}>
											<FormControl fullWidth={true}>
												<TextField
													label={intlService.GetFormattedMessage('app.account.partner-visible-account-label')}
													value={this.state.partnerSearch}
													placeholder={intlService.GetFormattedMessage(
														'admin.account-list-search-filter-placeholder-label'
													)}
													onChange={(e) => this.setStateAfterCancellingActiveRequests('partnerSearch', e.target.value)}
													variant='outlined'
												/>
											</FormControl>
										</Grid>
									)}
									{/*  Status filter*/}

									<Grid item={true} lg={3} md={3} sm={12} xs={12}>
										<FormControl fullWidth={true}>
											<TextField
												inputProps={{
													'data-testid': 'account-status-filter',
												}}
												label={intlService.GetFormattedMessage('app.customer-status')}
												select={true}
												value={this.state.selectedStatusFilterValues}
												onChange={(e: React.ChangeEvent) => {
													this.filterHelperFunc(
														e,
														[...this.customerFilter.accountStatus],
														'selectedStatusFilterValues',
														'selectAllStatusSelection'
													);
												}}
												SelectProps={{
													open: this.state.isOpenStatusFilter,
													multiple: true,
													onClose: async () => {
														this.setState({
															...this.state,
															...this.prevFiltersInfo,
															isOpenStatusFilter: false,
															fetchData: false,
														});
													},
													onOpen: () =>
														this.setState({
															isOpenStatusFilter: !this.state.isOpenStatusFilter,
														}),
													renderValue: (selected) => {
														return this.state.selectAllStatusSelection
															? AllLabel
															: (selected as string[]).map((x) => x).join(', ');
													},
												}}
												variant='outlined'
											>
												<MenuItem
													key={intlService.GetFormattedMessage('app.filter-select-all')}
													value={intlService.GetFormattedMessage('app.filter-select-all')}
												>
													<Checkbox checked={this.state.selectAllStatusSelection} />
													<ListItemText primary={intlService.GetFormattedMessage('app.filter-select-all')} />
												</MenuItem>
												{this.customerFilter.accountStatus.map((x) => (
													<MenuItem key={x} value={x} disabled={this.state.disabledCheckBox[x]}>
														<Checkbox checked={this.state.selectedStatusFilterValues.includes(x)} />
														<ListItemText primary={x} />
													</MenuItem>
												))}
												<MenuItem
													className='text-center'
													key={intlService.GetFormattedMessage('app.filter-done')}
													value={intlService.GetFormattedMessage('app.filter-done')}
												>
													<ListItemText primary={intlService.GetFormattedMessage('app.filter-done')} />
												</MenuItem>
											</TextField>
										</FormControl>
									</Grid>
								</Grid>
								{/*  customer table*/}
								<Grid container={true}>
									<Table<models.IAdminTreeTableData>
										columns={this.getGridColumns()}
										data={this.state.data}
										dataLoading={this.state.dataLoading}
										onRowClick={(data: models.IAdminTreeTableData) => this.goToAccountDetails(data)}
										applyRowColor={true}
									/>
								</Grid>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</React.Fragment>
		);
	}

	private updateLevelTypeFilter = () => {
		const newLevelType =
			this.props.match.params.levelType === AccountLevelEnum.Customer.toLowerCase()
				? AccountLevelEnum.Customer
				: AccountLevelEnum.Partner;

		const routePath =
			this.props.match.params.levelType === AccountLevelEnum.Customer.toLowerCase()
				? models.Module.CustomerAccounts.url
				: models.Module.PartnerAccounts.url;

		history.replace(routePath);

		this.setState({
			selectedLevelTypeFilterValue: newLevelType,
			customerSearch: '',
			partnerSearch: '',
			isPartnerFilter: newLevelType === AccountLevelEnum.Partner,
		});
	};

	private renderCustomerSearchFormField = () => {
		return (
			<FormControl fullWidth={true}>
				<TextField
					label={intlService.GetFormattedMessage('admin.account-list-search-filter-label')}
					placeholder={intlService.GetFormattedMessage('admin.account-list-search-filter-placeholder-label')}
					value={this.state.customerSearch}
					disabled={this.state.isPartnerFilter}
					onChange={(e) => this.setStateAfterCancellingActiveRequests('customerSearch', e.target.value)}
					variant='outlined'
				/>
			</FormControl>
		);
	};

	private filterHelperFunc(
		event: React.ChangeEvent<any>,
		rootFilterList: string[],
		stateKeyName: keyof models.ICustomerListState,
		selectAllStateName: keyof models.ICustomerListState
	) {
		switch (event.target.value.includes(done)) {
			case true:
				this.prevFiltersInfo = {
					...this.prevFiltersInfo,
					[stateKeyName]: this.state[stateKeyName],
					disabledCheckBox: { ...this.state.disabledCheckBox },
					selectAllStatusSelection: this.state.selectAllStatusSelection,
				};
				this.performActionOnDone(stateKeyName);
				break;
			case false:
				this.applyFiltersCorrectly(event.target.value, rootFilterList, stateKeyName, selectAllStateName);
				break;
		}
	}

	private renderCustomerSearchInput() {
		return (
			<Grid item={true} lg={4} md={6} sm={12} xs={12}>
				{this.state.selectedLevelTypeFilterValue === AccountLevelEnum.Partner ? (
					<Tooltip
						title={intlService.GetFormattedMessage('admin.account-list-customer-filter-disabled-lebel')}
						placement='top'
						arrow={true}
						disableHoverListener={!this.state.isPartnerFilter}
					>
						{this.renderCustomerSearchFormField()}
					</Tooltip>
				) : (
					this.renderCustomerSearchFormField()
				)}
			</Grid>
		);
	}

	private onAccountLevelTypeChange = (newValue: any) => {
		if (newValue !== null) {
			if (this.isAdminAccount) {
				history.push(
					newValue === AccountLevelEnum.Partner ? models.Module.PartnerAccounts.url : models.Module.CustomerAccounts.url
				);
				return;
			}

			this.setState({
				selectedLevelTypeFilterValue: newValue,
				customerSearch: '',
				partnerSearch: '',
				isPartnerFilter: newValue === AccountLevelEnum.Partner,
			});
		}
	};

	private getGridColumns = (): Array<Column<models.IAdminTreeTableData>> => {
		return [
			{
				accessor: 'companyName',
				Header: intlService.GetFormattedMessage('app.account.company-label'),
				disableSortBy: true,
			},
			{
				accessor: 'visibleAccountNumber',
				Header: intlService.GetFormattedMessage('app.api-key.visible-account-number'),
				disableSortBy: true,
				width: 190,
			},
			{
				accessor: 'subscriptionPlan',
				Header: intlService.GetFormattedMessage('admin.customer-list.subscription-plan-label'),
				disableSortBy: true,
				width: 100,
			},
			{
				accessor: 'status',
				Header: intlService.GetFormattedMessage('app.account.admin-account-status-label'),
				disableSortBy: true,
				width: 100,
			},
		];
	};

	private getChildAccount = async (expandedRowIds: string[], loadFromServer = true) => {
		try {
			if (loadFromServer) {
				this.setState({
					dataLoading: true,
					data: [],
				});
			}
			// Filter expandedRowId for which we need to fetch child
			const rowIdsWithNotLoadedChildren = loadFromServer
				? expandedRowIds
				: expandedRowIds.filter(
						(rowId) =>
							this.state.data.findIndex((data: models.IAdminTreeTableData) => data.parentAccountId === rowId) === -1
				  );
			// For last fetch index fetch child
			if (loadFromServer || rowIdsWithNotLoadedChildren.length) {
				const res = await adminAccountService.getAllAccountForAdmin(
					this.state.selectedStatusFilterValues,
					SharedService.getEnumKeyByEnumValue(AccountSubscriptionEnum, this.state.selectedSubscriptionsFilterValues),
					this.state.customerSearch,
					this.state.partnerSearch,
					this.state.selectedLevelTypeFilterValue,
					this.props.axiosCancellationToken
				);

				if (res.length === 0) {
					this.setState({
						expandedRowIds,
						dataLoading: false,
					});
					return;
				}
				const treeTableData = this.prepareTreeTableData(res);
				this.setState({
					data: loadFromServer ? treeTableData : this.state.data.concat(...treeTableData),
					expandedRowIds,
					dataLoading: false,
				});
			} else {
				this.setState({
					expandedRowIds,
				});
			}
		} catch (e) {
			if (!Axios.isCancel(e)) {
				throw e;
			}
		}
	};

	private performActionOnDone(stateKeyName: string) {
		this.setState({
			isOpenStatusFilter: false,
			isOpenSubscriptionsFilter: false,
			fetchData: false,
		});
	}

	private goToAccountDetails(row: models.IAdminTreeTableData) {
		const route = this.isPartnerAccount
			? models.Module.Customers.url
			: this.state.selectedLevelTypeFilterValue === AccountLevelEnum.Partner
			? models.Module.PartnerAccounts.url
			: models.Module.CustomerAccounts.url;

		const breadcrumbState = [
			{
				title: row.companyName,
				location: history.location,
			},
		];

		if (this.isAdminAccount) {
			breadcrumbState.unshift({
				title: this.state.selectedLevelTypeFilterValue,
				location: history.location,
			});
		}

		history.push(`${route}/${row.id}`, {
			account: { id: row.id },
			breadcrumb: breadcrumbState,
		});
	}

	private applyFiltersCorrectly(
		value: string[],
		rootFilterList: string[],
		stateKeyName: keyof models.ICustomerListState,
		selectAllStateName: keyof models.ICustomerListState
	) {
		const isSelectAllApplied = value.includes(intlService.GetFormattedMessage('app.filter-select-all'));
		const doneState: boolean = isSelectAllApplied && !this.state[selectAllStateName];
		value = value.filter((element) => element !== intlService.GetFormattedMessage('app.filter-select-all'));
		let disabled = {};
		forEach(rootFilterList, (element) => {
			if (this.state.disabledCheckBox[element]) {
				disabled = { ...this.state.disabledCheckBox, [element]: false };
			}
		});

		switch (doneState) {
			case true:
				value = rootFilterList;
				break;
			case false:
				// Used in case if user checked select-all again for deselecting all filters
				if (isSelectAllApplied) {
					const temp = value[0];
					value = [];
					value.push(temp);
					disabled = {
						...this.state.disabledCheckBox,
						[value[0]]: !this.state.disabledCheckBox[value[0]],
					};
				}
				break;
		}

		// if no filter is selected, then adding 'active' filter option by default in disabled mode
		if (value.length === 0) {
			{
				value.push(rootFilterList[0]);
				disabled = {
					...this.state.disabledCheckBox,
					[value[0]]: true,
				};
			}
		}

		this.setState({
			...this.state,
			[stateKeyName]: value,
			[selectAllStateName]: value.length === rootFilterList.length ? true : doneState,
			disabledCheckBox: disabled,
		});
	}

	/**
	 * Return ITreeTableData
	 */
	private prepareTreeTableData = (accounts: models.IChildAccountResponseVM[]): models.IAdminTreeTableData[] => {
		const treeTableData: models.IAdminTreeTableData[] = [];
		for (let i = 0; i < accounts.length; i++) {
			const account = accounts[i];
			const color = i % 2 === 0 ? ShadedTableRowColor : DefaultTableRowColor;
			treeTableData.push({
				role: account.role,
				companyName: account.companyName,
				email: account.email,
				id: account.accountId,
				userName: account.userName,
				joiningDate: (
					<FormattedDate
						{...constants.dateFormatOptions}
						value={sharedService.getNewDateIfNotExist(account.joiningDate)}
					/>
				),
				lastLoginDate: (
					<FormattedDate
						{...constants.dateFormatOptions}
						value={sharedService.getNewDateIfNotExist(account.lastLoginDate)}
					/>
				),
				parentAccountId: account.parentAccountId,
				name: account.name,
				status: account.status,
				childCount: account.childCount,
				shipmentCount: account.shipmentCount,
				visibleAccountNumber: account.visibleAccountNumber ?? NotApplicable,
				partnerVisibleAccountNum: account.partnerVisibleAccountNum,
				backgroundColor: color,
				subscriptionPlan: AccountSubscriptionEnum[account.subscriptionPlan],
			});
		}

		return treeTableData;
	};

	private setStateAfterCancellingActiveRequests = (key: FilterType, value: any) => {
		const composedFunc = this.callAfterCancellingActiveRequests(() => {
			this.setState((prevState: models.ICustomerListState) => ({
				...prevState,
				currentPage: 1,
				[key]: value,
			}));
		});

		composedFunc();
	};

	private callAfterCancellingActiveRequests = (callback: (...args: any) => void) => {
		return async (...args: any) => {
			await this.props.cancelActiveRequests();
			callback(...args);
		};
	};
}
export default withRouter(withAxiosCancellation(withStyles(styles)(injectIntl(CustomerListComponent))));



// WEBPACK FOOTER //
// ./src/components/shared/customer-list.component.tsx